var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkinNum"},[_c('div',[_vm._v("NO: "+_vm._s(_vm.報到號碼))]),(_vm.withTime)?_c('div',[_vm._v("建議報到時間: "+_vm._s(_vm.person.建議時間))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }